import { kebabCase } from 'lodash';

export function getCustomerNumberFromPathname() {
  const match = window.location.pathname.match(/\/customer\/([^/]+)/);
  const customerNumber = match ? match[1] : null;

  return customerNumber ? kebabCase(customerNumber) : undefined;
}

export type CustomerState<T> = {
  [customerNumber: string]: T
}

export type TStateFunction<T> = (statePart: T) => T
export function wrapStateWithCustomerNumber<T>(statePart: T | TStateFunction<T>, state: CustomerState<T>, defaultValue: T): CustomerState<T> {
  const customerNumber = getCustomerNumberFromPathname();

  if (!customerNumber) {
    return { ...state };
  }

  let newState
  if (typeof statePart === 'function') {
    const currentState = unwrapCustomerState<T>(state);
    newState = (statePart as TStateFunction<T>)(currentState ?? defaultValue);
  } else {
    newState = statePart
  }

  if (!newState) {
    return { ...state };
  }

  return {
    ...state,
    [customerNumber]: newState,
  }
}

export function unwrapCustomerState<T>(state: CustomerState<T>) {
  const customerNumber = getCustomerNumberFromPathname();

  if (!customerNumber) {
    return undefined;
  }

  return state[customerNumber];
}